<template>
  <div class="dividePage">
    <div class="wrap">
      <van-radio-group v-model="radioCheck">
        <div class="divide-row">
          <span>红利再投资</span>
          <van-radio
            name="0"
            checked-color="#E12817"
            icon-size="18px"
          ></van-radio>
        </div>
        <p class="introduce">
          收益分配用于追加投资。
        </p>
        <div class="line"></div>
        <div class="divide-row">
          <span>现金分红</span>
          <van-radio
            name="1"
            checked-color="#E12817"
            icon-size="18px"
          ></van-radio>
        </div>
        <p class="introduce">收益分配采用现金方式。</p>
        <div class="line" style="margin-bottom: 0.08rem;"></div>
        <div class="divide-choose-tip" v-if="$route.query.dividendMethod=='1'">当前分红方式：现金分红</div>
        <div class="divide-choose-tip" v-else>当前分红方式：红利再投资</div>
        <div class="tip">
          <p>1、设置分红方式的受理结果以份额登记机构确认为准。</p>
          <p>2、交易日15时后的变更，将作为下一交易日申请。 </p>
          <p>3、同一交易日内多次提交以最后一次为准。</p>
        </div>
      </van-radio-group>

      <!-- 变更记录 -->
      <div class="divide-list-top" @click="moreClick" v-if="dividendModeArr.length > 0">
        <p>分红方式变更记录</p>
        <van-icon name="arrow" class="customIcon" />
      </div>
      <div class="tableHeader"  v-if="dividendModeArr.length > 0">
        <div class="tabListItem header-grey width18">原分红方式</div>
        <div class="tabListItem header-grey width28">变更后分红方式</div>
        <div class="tabListItem width17 header-grey">申请时间</div>
        <div class="tabListItem width17 header-grey">变更渠道</div>
        <div class="tabListItem width17 header-grey">确认状态</div>
      </div>
      <div v-for="item in dividendModeArr">
        <div class="divider"></div>
        <div class="list">
          <p class="tabListItem width18">
            {{ transDividendMethod(item.currentDividendMethod) }}
          </p>
          <p class="tabListItem width28">
            {{ transDividendMethod(item.changeDividendMethod) }}
          </p>
          <p class="tabListItem width17">{{ item.appointmentDate }}</p>
          <p class="tabListItem width17">{{ transSource(item.orderSource) }}</p>
          <p class="tabListItem red width17" v-if="item.confirmStatus == '10'">待确认</p>
          <p class="tabListItem green width17" v-else-if="item.confirmStatus == '30'">
            确认失败
          </p>
          <p class="tabListItem green width17" v-else>已确认</p>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="comfirm-btn" @click="comfirmClick">确定</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "modifyDividendWay",
  data() {
    return {
      radioCheck: "",
      dividendModeArr: [],
    };
  },
  computed: {
    ...mapState(["setHeader", "personalAccount"]),
  },
  mounted() {
    this.radioCheck = this.$route.query.dividendMethod;
    if (this.$route.query.dividendModeList) {
      this.dividendModeArr = JSON.parse(this.$route.query.dividendModeList).slice(0,3);
    }
  },
  methods: {
    transDividendMethod(method) {
      if (method == "0") {
        return "红利再投资";
      }
      if (method == "1") {
        return "现金分红";
      }
      return "--";
    },
    transSource(source) {
      if (source == "10") {
        return "APP";
      }
      if (source == "20") {
        return "陆金汇";
      }
      return "--";
    },
    moreClick() {
      this.$router.push({
        path: "/dividendList",
        query:{
          dividendModes: this.$route.query.dividendModeList
        }
      });
    },
    comfirmClick() {
      let mac_addr = this.IOS.ios
        ? this.$store.state.getHeadInfo.ip
        : this.setHeader.ip;
      let _this = this;
      let params = {
        orgCommonId: this.personalAccount.orgCommonId,
        groupCommonId: this.personalAccount.groupCommonId,
        productId: this.$route.query.productId,
        sysContractNo: this.$route.query.sysContractNo,
        currentDividendMethod: this.$route.query.dividendMethod,
        changeDividendMethod: this.radioCheck,
        companyId: this.personalAccount.company || this.personalAccount.companyId,
        ipAddr: mac_addr,
      };
      var url = this.$api.setPubDividendMode;
      if (this.$route.query.isPrivate) {
        url = this.$api.setPriDividendMode;
      }
      this.$post(url, params).then((res) => {
        if (res.code === 10000) {
          _this.$dialog
            .alert({
              message: `已成功提交！`,
              messageAlign: "center",
            })
            .then(() => {
              _this.$router.go(-1);
            });
        } else {
          _this.$toast(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dividePage {
  background-color: #ffffff;
  height: 100vh;
  .wrap {
    padding: 0.16rem;
    color: #666666;
    font-size: 0.15rem;
    padding-bottom: 1rem;
  }
  .divide-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 0.16rem;
    font-weight: 500;
    color: #333333;
    padding-bottom: 0.16rem;
  }
  .introduce {
    text-align: left;
    padding-bottom: 0.16rem;
  }
  .line {
    height: 1px;
    background-color: #eeeeee;
    margin-bottom: 0.16rem;
  }
  .divide-list-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.4rem;
    font-weight: 500;
    color: #333333;
    font-size: 0.16rem;
  }
  .divider {
    height: 1px;
    background-color: #eeeeee;
    margin-top: 0.16rem;
    margin-bottom: 0.16rem;
  }
  .tableHeader {
    margin-top: 0.16rem;
    padding-top: 0.16rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 0.01rem solid #eeeeee;
    font-size: 0.11rem;
  }
  .list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 0.11rem;
    color: #333;
    font-weight: 400;
    align-items: center;
    .red {
      color: #e12817;
    }
    .green {
      color: #00b578;
    }
  }
  .header-grey {
    color: #999999 !important;
  }
  .tabListItem {
    color: #333;
    text-align: center;
    box-sizing: border-box;

    &:first-of-type {
      text-align: left;
    }
    &:last-of-type {
      // text-align: right;
    }
  }
  .customIcon {
    margin-left: 0.04rem;
    font-size: 0.15rem;
    color: #999999;
  }
  .width17 {
    min-width: 17%;
  };
  .width18 {
    min-width: 18%;
  }
  .width28 {
    min-width: 28%;
  }
  .bottom {
    position: fixed;
    bottom: 0;
    height: 0.84rem;
    border-top: 1px solid #eeeeee;
    width: 100%;
    font-size: 0.16rem;
    .comfirm-btn {
      margin: 0.18rem 0.16rem;
      background-color: #e12817;
      color: #ffffff;
      height: 0.49rem;
      border-radius: 0.245rem;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .divide-choose-tip {
      text-align: left;
  }
  .tip {
    text-align: left;
    font-size: 0.12rem;
    margin-top: 0.24rem;
    color: #BB874A;
    line-height: 0.17rem;
  }
  .commonTip {
    color: #333;
    .title {
      font-size: 0.18rem;
      font-weight: bold;
      padding: 0.24rem 0 0;
      text-align: center;
    }
    .stopListContent {
      font-size: 0.15rem;
      padding: 0.08rem 0.16rem 0.24rem;
      text-align: left;
      .diffStyle {
        color: #d7ae74;
      }
    }
    /deep/.van-hairline--top::after {
      border-color: #e5e5e5;
    }
  }
}
</style>